/* eslint-disable stylistic/quote-props */
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from "react";

import { Heading as BaseHeading } from "@radix-ui/themes";

import { semanticColor as semanticColorMapper } from "../styles";
import { type PttProps, ptt } from "../util.props-to-tailwind";

type HeadingProps = {
  semanticColor?: keyof typeof semanticColorMapper;
} & ComponentPropsWithoutRef<typeof BaseHeading>
& Pick<PttProps, "leading" | "lineClamp">;
type HeadingRef = ElementRef<typeof BaseHeading>;

const Heading = forwardRef<
  HeadingRef,
  HeadingProps
>((props, ref) => {
  const {
    className,
    color,
    leading,
    lineClamp,
    semanticColor,
    weight = "medium",
    ...headingProps
  } = props;

  return (
    <BaseHeading
      {...headingProps}
      className={ptt({
        className,
        leading,
        lineClamp,
      })}
      color={(semanticColor && semanticColorMapper[semanticColor]) || color}
      ref={ref}
      weight={weight}
    />
  );
});
Heading.displayName = BaseHeading.displayName;

export { Heading };
